module.exports = __webpack_public_path__ + "img/android.7d14b766.svg";